import script from "./MenuShelves.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuShelves.vue?vue&type=script&setup=true&lang=js"

import "./MenuShelves.vue?vue&type=style&index=0&id=4986d16a&lang=css"

const __exports__ = script;

export default __exports__